import { User } from 'models/User'
import { usersCollection } from 'providers/Firestore'

class UserService {
  async getUser(uid: string) {
    const doc = await usersCollection.doc(uid).get()

    return Object.assign(new User(), { ...doc.data() })
  }

  async save(user: User) {
    await usersCollection.doc(user.uid).set({...user})
  }

  async saveIfNoExists(user: User) {
    const doc = await usersCollection.doc(user.uid).get()

    if (!doc.exists) {
      this.save(user)
    }
  }
}

export default new UserService();
